import { RadioButton, RadioGroup } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { toSecondaryDataFormat, trackSecondaryDataFormatEvent } from '@/analytics/snowplow/tracking';
import { showRankAtom } from '@/atoms/table';

export const ShowRankToggle = () => {
  const { t } = useTranslation('visualisation');
  const [showRank, setShowRank] = useAtom(showRankAtom);

  const handleShowRankChange = (newShowRank: boolean) => {
    const previousConfiguration = toSecondaryDataFormat(showRank);
    const updatedConfiguration = toSecondaryDataFormat(newShowRank);

    setShowRank(newShowRank);
    trackSecondaryDataFormatEvent({ previousConfiguration, updatedConfiguration });
  };

  return (
    <RadioGroup groupId="secondary-data-format-group" groupTitle={t('secondaryDataFormat.title')} size="regular">
      <RadioButton
        checked={!showRank}
        onChange={() => handleShowRankChange(false)}
        id="secondary-data-format-none"
        label={t('secondaryDataFormat.none')}
        value="false"
        size="small"
      />
      <RadioButton
        checked={showRank}
        onChange={() => handleShowRankChange(true)}
        id="secondary-data-format-rank"
        label={t('secondaryDataFormat.rank')}
        value="true"
        size="small"
      />
    </RadioGroup>
  );
};
